import React from 'react'

const Viewmore_table = () => {
    return (
        <div>

            <div className="modal fade" id="detailsModal" tabindex="-1" aria-labelledby="detailsModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content shadow-lg">
                        <div className="modal-header">
                            <h5 className="modal-title font-bold" id="detailsModalLabel">
                                View Lead
                            </h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div class="">
                               

                                <div class="card">
                                    <div class="card-body">
                                        <h2 class="section-title">Basic Details</h2>
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <p><strong>Project:</strong> Sample Project Name</p>
                                            </div>
                                            <div class="col-md-6">
                                                <p><strong>Sr No:</strong> 00123</p>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <p><strong>Date:</strong> 2024-12-12</p>
                                            </div>
                                            <div class="col-md-6">
                                                <p><strong>Approach:</strong> Direct</p>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <p><strong>Mode:</strong> Walk In</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <h2 class="section-title">Client Details</h2>
                                        <div class="row mb-3">
                                            <div class="col-md-4">
                                                <p><strong>Name:</strong> John Doe</p>
                                            </div>
                                            <div class="col-md-4">
                                                <p><strong>Mobile No:</strong> +1 234 567 890</p>
                                            </div>
                                            <div class="col-md-4">
                                                <p><strong>Email ID:</strong> john.doe@example.com</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <h2 class="section-title">Status</h2>
                                        <div class="row mb-3">
                                            <div class="col-md-4">
                                                <p><strong>Status:</strong> HOT</p>
                                            </div>
                                            <div class="col-md-4">
                                                <p><strong>Stage:</strong> Contacted (Stage 2)</p>
                                            </div>
                                            <div class="col-md-4">
                                                <p><strong>Response:</strong> Interested</p>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-4">
                                                <p><strong>Last Follow Up:</strong> 2024-12-10</p>
                                            </div>
                                            <div class="col-md-4">
                                                <p><strong>Next Follow Up:</strong> 2024-12-15</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <h2 class="section-title">Site Visit Details</h2>
                                        <div class="row mb-3">
                                            <div class="col-md-4">
                                                <p><strong>Site Visit:</strong> Scheduled</p>
                                            </div>
                                            <div class="col-md-4">
                                                <p><strong>Site Visit Time:</strong> 2024-12-14 10:00 AM</p>
                                            </div>
                                            <div class="col-md-4">
                                                <p><strong>Site Visit Remarks:</strong> Client requested a morning slot.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <h2 class="section-title">Other</h2>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <p><strong>Remarks:</strong> Client is highly interested but has a few budget concerns.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="modal-footer justify-content-between p-3 bg-light">
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Viewmore_table
